import ModifiersMap from './mixins/ModifiersMap.vue'

export {
    ModifiersMap
}